export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "package_group_planning_alert": {
            "real_num_pgs": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_pgs")), " pallets registrados"])}
          }
        }
      },
      "en": {
        "model": {
          "package_group_planning_alert": {
            "real_num_pgs": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_pgs")), " pallets registered"])}
          }
        }
      }
    }
  })
}